import { render, staticRenderFns } from "./ButtonBookmark.vue?vue&type=template&id=5164f626&"
import script from "./ButtonBookmark.vue?vue&type=script&lang=js&"
export * from "./ButtonBookmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports